<manage-wrapper
  *ngIf="!!resource && { brief: resourceBriefs[resource?.id] } as r"
  [canEditMain]="!readOnly"
  [topToggleText]="'RESOURCE ' + (resource.confirmed ? '' : 'NOT ' ) + 'CONFIRMED'"
  [topToggled]="!!resource.confirmed"
  [entityTitle]="resource.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="readOnly"
  [labels]="resource.labels"
  [labelMap]="labelMap"
  [labelList]="labels"
  [clipLabel]="readOnly ? '' : clipLabel"
  [deleteTitle]="'Delete resource: ' + resource.name || 'Unnamed resource'"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  [titlePlaceholder]="'Resource name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Manage Resource'"
  [type]="'resource'"
  [showStars]="true"
  [stars]="resource.stars || 0"
  (saveStars)="saveStars($event)"
  (onToggle)="toggleResourceConfirmed()"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (onDelete)="deleteResource()"
  (onDuplicate)="duplicateResource()"
  (saveTitle)="updateResourceName($event)"
  (onClip)="clip()"
>
  <entity-types class="afterTitle"
    [readOnly]="readOnly"
    [entityType]="'resource'"
    [entity]="resource"
  ></entity-types>

  <ng-container *ngIf="!selectedTab || selectedTab?.id === tabs.details">

    <ng-container *ngIf="!readOnly">
      <div>Share webform to receive resource profile information.</div>
      <binary-share-toggle
        style="display: block; margin-bottom: 20px;"
        [type]="'profile'"
        [shareType]="shareTypes.resource"
        [hideBottom]="!resourceShareable"
        [shareableFormat]="'oneLine'"
        [shareCode]="resourceShareable?.code"
        [hint]="'Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.'"
        [title]="'Profile webform'"
        [shareTitle]="'YOUR SHAREABLE WEBFORM:'"
        [generatingCode]="generatingEditCode"
        [status]="resourceShareable?.status || 'Off'"
        (toggle)="toggleResourceProfile()"
        (changeStatus)="changeResourceProfileStatus($event)"
      ></binary-share-toggle>
    </ng-container>

    <image-uploader style="margin-top: 20px;"
      [id]="resource?.id"
      (newUrls)="changeLogo($event)"
      [immediate]="true" 
      [isLogo]="true"
      [displayType]="imageUploaderDisplayTypes.widePodLogo"
      [thumbUrl]="resource.logoUrl" 
      [photoUrl]="resource.fullLogoUrl"
      [eventId]="event?.eventId"
      [saveName]="resource.name"
      [type]="'resource'" 
      [subtype]="'logo'" 
      [placeholder]="'Add logo'" 
      [uploadText]="'UPLOAD LOGO'"
    ></image-uploader>

    <h3 style="margin-top: 20px;">About the resource</h3>
    <input-editor class="description"
      [object]="resource" 
      [prop]="'about'"
      [placeholder]="'About resource...'"
      [disabled]="readOnly"
      (changed)="saveResource()"
    ></input-editor>

    <manage-social [links]="resource?.social" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <resource-contact-list *ngIf="resource && event" [resource]="resource" [public]="false" [eventId]="event.eventId" (updated)="saveResource()"></resource-contact-list>

    <custom-questions-app
      [entity]="resource"
      [entityType]="'resource'"
      (updateQuestion)="updateCustomQuestion($event)"
    ></custom-questions-app>


  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.contact">
    <tip-text class="top" [type]="'tip'" [head]="'Tip:'" [body]="'The workforce contact will appear in the resource brief.'"></tip-text>
    <manage-contact
      [workforceContactEmail]="resource?.workforceContactEmail"
      [readOnly]="readOnly"
      (changeContact)="changeWorkforceContact($event)"
    ></manage-contact>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.assets">
    <assets 
      [title]="'Associated Assets'"
      [entityHolderName]="'resource'"
      [associatedId]="resource.id"
      [assetIds]="associatedAssetIds"
      [readOnly]="readOnly"
    ></assets>

    <edit-associated-assets-manager *ngIf="!!resource && !readOnly" style="margin-top: 30px;"
      [type]="'resource'"
      [entity]="resource"
      [view]="'shareable'"
      (toggleShowEditAssetsLinkInBrief)="resource.showAssetsLinkInBrief = $event; saveResource()"
    ></edit-associated-assets-manager>

  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.schedule">
    <app-brief *ngIf="!!event && !!resource"
      [resource]="resource"
      [briefType]="'resource'"
      [briefInfo]="r.brief"
      [timelineOnly]="true"
    ></app-brief>
  </ng-container>

  
  <ng-container *ngIf="selectedTab?.id === tabs?.quotes && !!resource">
    <add-manage-wrapper 
      *ngIf="{ quoteInfos: (resource?.quoteIds || []) | idsToItems:(quoteInfos || {}) } as d"
      [hideHRule]="true" 
      [readOnly]="!!readOnly || !budgetAccess"
      [openLabel]="addingQuote ? 'CREATING QUOTE...' : 'ADD QUOTE REQUEST'" 
      (open)="addingQuote ? null : addQuoteRequest()">
      <div *ngIf="!d.quoteInfos.length" class="empty-text">No quotes.</div>
      <ng-container *ngFor="let quoteInfo of d.quoteInfos">
        <status-wrapper
          class="wide"
          [ngClass]="{ clickable: !readOnly }"
          [middleText]="quoteInfo.referenceNo"
          [wideFormat]="true"
          [status]="quoteInfo.status"
          [hideStatus]="false"
          [threeDotOptions]="quoteThreeDotOptions"
          [statusOptions]="quoteStatusOptions"
          [quoteStatus]="quoteInfo.quoteStatus"
          [readOnly]="readOnly || !budgetAccess"
          (click)="readOnly || !budgetAccess ? null : dotMenuSelection(quoteInfo, { event: null, option: 'manage' })"
          (threeDotSelection)="dotMenuSelection(quoteInfo, $event)" 
          (changeStatus)="changeQuoteInfoStatus(quoteInfo, $event)"
          (changeQuoteStatus)="changeQuoteStatus(quoteInfo, $event)"
          >
          <div class="wideContent">{{ quoteInfo.sectionName || 'Unnamed Quote' }}</div>
        </status-wrapper>
      </ng-container>
    </add-manage-wrapper>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.quickNotes">
    <chat-box [isNotes]="true" [comments]="resource?.quickNotes || []" [readOnly]="!event || event.is_readonly" (quickNotesChanged)="saveQuickNotes($event)" ></chat-box>
  </ng-container>

  <entity-tasks *ngIf="selectedTab?.id === tabs.tasks" [entity]="resource" [changeDetectorRef]="changeDetectorRef"></entity-tasks>

  <ng-container *ngIf="selectedTab?.id === tabs.infoForResource">
    <tip-text class="top" [head]="'Tip:'" [body]="'Information added here will only appear in <strong>'+resource.name+'&rsquo;s</strong> resource brief.'"></tip-text>
    <title-icon [titleIcon]="'description18'" [title]="'Information for '+resource.name+' only'"></title-icon>
    <div class="empty-text">Add information or instructions specific to this resource</div>
    <informable 
      [singleSectionOnly]="true"
      [informableType]="'resource'" 
      [informableKey]="resource.id" 
      [noItemsMessage]="''"
    ></informable>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.configBrief">
    <h3 style="padding: 20px 0 ; ">Configure actions to include in {{ resource.name }}'s resource brief</h3>
    <tip-text class="top" [type]="'important'" [head]="'Important'" [body]="'Actions will automatically appear in '+ resource.name +'\'s Resource Brief when the below configurations are set to &ldquo;ON&rdquo;'"></tip-text>
    <h5>PROFILE</h5>
    <add-link-to-brief-wrapper
      style="margin-top: 10px; display: block;"
      [title]="'<strong>Include profile webform</strong>'"
      [toggleOn]="resource.showEditProfileLinkInBrief"
      [selected]="resourceShareable?.status || 'Off'"
      (toggle)="updateShowEditProfileLinkInBrief()"
      (toggleStatus)="changeResourceProfileStatus($event)"
    ></add-link-to-brief-wrapper>

    <edit-associated-assets-manager *ngIf="!!resource" style="margin-top: 30px;"
      [type]="'resource'"
      [entity]="resource"
      [view]="'actions'"
      (toggleShowEditAssetsLinkInBrief)="resource.showAssetsLinkInBrief = $event; saveResource()"
    ></edit-associated-assets-manager>

    <h5 style="margin-top: 30px;">RESOURCE QUOTES</h5>
    <add-link-to-brief-wrapper 
      *ngFor="let quoteInfo of resource.quoteIds | idsToItems:quoteInfos; last as last"
      style="margin-top: 10px; display: block;"
      [title]="'<strong>Include quote webform</strong> for '+ quoteInfo.sectionName || 'unnamed quote'"
      [toggleOn]= "!!quoteInfo.editLinkInBrief && quoteInfo.status !== 'Off'"
      [disabled]="readOnly"
      [selected]="quoteInfo.status || 'Off'"
      (toggle)="updateShowEditQuoteInBrief(quoteInfo)"
      (toggleStatus)="setQuoteInfoStatus(quoteInfo, $event)"
    ></add-link-to-brief-wrapper>

    <manage-terms [type]="'resource'" [entity]="resource" [readOnly]="readOnly" (saveEntity)="saveResource()"></manage-terms> 
  </ng-container>
  
  <ng-container *ngIf="selectedTab?.id === tabs.preview && { contact: resource.contacts | findById:resource.primaryContactId } as vars">
    <binary-share-toggle
      class="brief"
      [type]="'brief'"
      [contactName]="vars.contact?.firstName || ''"
      [contactEmail]="vars.contact?.email || ''"
      [shareType]="shareTypes.resourceBrief"
      [shareableFormat]="'oneLine'"
      [shareCode]="r.brief?.id"
      [hint]="'Note: The shareable webpage below is dynamic and will always load the current information for the resource.'"
      [title]="'Resource Brief webpage'"
      [shareTitle]="'Your shareable webpage:'"
      [status]="r.brief?.status || 'Off'"
      [alwaysOnMessage]="'Share the resource brief as a webpage.'"
      (toggle)="shareUrl($event)"
      (changeStatus)="shareUrl($event === 'Off' ? false : true)"
    ></binary-share-toggle>
    <tip-text class="top" class="brief-tip bottom" [type]="'tip'" [head]="'Tip:'" [body]="'Below is what <strong>' + resource.name + '</strong> will see when they view their brief.\n\nA resource\'s brief is built automatically from other sections of Joi.'"></tip-text>

    <hr class="big-rule" />
      <app-brief *ngIf="!!event && !!resource"
        [resource]="resource"
        [briefType]="'resource'"
        [briefInfo]="r.brief"
      ></app-brief>
  </ng-container>

</manage-wrapper>


